// Графемы для заглушек (код команды, инициалы): огласовки (\p{M}) не отрываются от буквы, суррогатные пары не рвутся.
// Intl.Segmenter есть не везде (старые webview) — запасной путь по кодовым точкам, знак \p{M} держится за предыдущей.

const MARK = /^\p{M}$/u;

export function graphemes(text: string): string[] {
  const Segmenter = typeof Intl === 'undefined' ? undefined : Intl.Segmenter;
  if (typeof Segmenter === 'function') {
    return Array.from(new Segmenter(undefined, { granularity: 'grapheme' }).segment(text), (s) => s.segment);
  }
  const out: string[] = [];
  for (const cp of text) {
    if (MARK.test(cp) && out.length > 0) out[out.length - 1] += cp;
    else out.push(cp);
  }
  return out;
}

/** Первые n графем текста, в котором оставлены только буквы, знаки огласовки и цифры. */
export function leadingGraphemes(text: string, n: number): string {
  return graphemes(text.replace(/[^\p{L}\p{M}\p{N}]/gu, '')).slice(0, n).join('');
}
